var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIconTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#007db3;}.b{fill:none;stroke:#fff;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-893 -473)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(893 473)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(901 481.365)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 12.691,
    transform: "translate(6.346 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 12.691,
    transform: "translate(12.691 6.346) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconTwo);
export default __webpack_public_path__ + "static/media/PlusIconTwo.046d3297f70cbb2ffd5def03d2c52ca7.svg";
export { ForwardRef as ReactComponent };